import { render, staticRenderFns } from "./SHeaderNotice.vue?vue&type=template&id=781c09be&scoped=true&"
import script from "./SHeaderNotice.vue?vue&type=script&lang=js&"
export * from "./SHeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./SHeaderNotice.vue?vue&type=style&index=0&id=781c09be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c09be",
  null
  
)

export default component.exports